

























import { Component, Prop, Emit, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { appStore } from '@/store'
import { IAtomSelectItem } from './AtomSelect.type'

@Component
export default class AtomSelect extends ComponentVue {
  @Ref()
  atomSelect!: any

  @Prop({ type: String })
  label!: string

  @Prop({ type: Array })
  items!: IAtomSelectItem[]

  @Prop({ type: [Array, String, Number, Boolean] })
  value!: string[] | string | number | boolean

  @Prop({ type: Boolean })
  error!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  @Prop({ type: Number, default: 500 })
  emitIntervalMs!: number

  isEmit: boolean = true

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get style(): object {
    return {
      'font-size': this.fontSize + 'px'
    }
  }

  @Emit('input')
  onChange() {}

  onKeydownEnter() {
    if (this.isEmit) {
      this.$emit('keydown:enter')
      this.isEmit = false

      setTimeout(() => (this.isEmit = true), this.emitIntervalMs)
    }
  }
}
